import { ReactElement } from 'react';

import { FormContextValues } from '@dreryk/react-common';
import { FormLabel, StyledFlex, TextView } from '@dreryk/react-components';

import { medicalServiceTranslationKeys } from '../../../translations';

import { WithNameForInvoicing } from './nameForInvoicing.types';

type MedicalServiceNameForInvoicingTextViewProps = Pick<FormContextValues<WithNameForInvoicing>, 'watch'> & {
   readonly children: ReactElement | ReactElement[];
   readonly disabled?: boolean;
};

export const MedicalServiceNameForInvoicingTextView = (
   props: MedicalServiceNameForInvoicingTextViewProps
): JSX.Element => {
   const { usingNameAsNameForInvoicing } = props.watch(['usingNameAsNameForInvoicing']);
   return (
      <TextView
         testId={'nameForInvoicing'}
         label={
            <FormLabel
               testId={'nameForInvoicing'}
               label={medicalServiceTranslationKeys.shared.nameForInvoicing.textView.label}
               disabled={props.disabled}
               required={!props.disabled && !usingNameAsNameForInvoicing}
            />
         }
      >
         <StyledFlex direction={'column'} gap={'8px'}>
            {props.children}
         </StyledFlex>
      </TextView>
   );
};
